//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { props } from './props';
import { defineComponent } from '../utils/create';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', {
    class: {
      'cb-diamond': true,
      default: _vm.isBoth,
      'is-coin': _vm.isCoin,
      'is-diamond': _vm.isDiamond,
      'is-before': _vm.before,
      'is-after': !_vm.before,
      dark: _vm.isDarkTheme
    }
  }, [_vm._t("default")], 2);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-bf69c6f8',
  render,
  name: 'CbDiamond',
  props,
  computed: {
    isDiamond() {
      return this.type === 'diamond';
    },
    isCoin() {
      return this.type === 'coin';
    },
    isBoth() {
      return this.type === 'diamond-with-coin';
    },
    isDarkTheme() {
      return this.theme === 'dark';
    }
  }
});